<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span
          v-if="item.redirect==='noRedirect'||index==levelList.length-1"
          class="no-redirect"
        >{{ item.meta.title }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import pathToRegexp from 'path-to-regexp'
import Maincontainer from '../../layout/components/MainContainer'
export default {
  components: {
    Maincontainer
  },
  data() {
    return {
      levelList: [],
      editableTabsValue2: '/changeEmail'
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      const first = matched[0]

      if (!this.isDashboard(first)) {
        matched = [{ path: '/', meta: { title: '' }}].concat(matched)
      }
      const list = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
      const flag = this.levelList.indexOf(list)
      console.log(flag, list)
     
      if (flag == -1) {
      
        list[0].tabIndex=''+this.index
        this.levelList.push(list[0])//路由列表
        this.index++
      } else {
        return
      }
      console.log('a',this.levelList)
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    },
    removeTab(targetName) {
      for (var i = 0; i < this.levelList.length; i++) {
        const index = this.levelList.indexOf(targetName)
        console.log(index)
        this.levelList.splice(index)
      }
    },
    jump(data) {
      this.$router.push(data.name)
    }

  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 14px;
  margin-left: 8px;

  .no-redirect {
    color: #FFA940;
    cursor: text;
    font-size: 14px;
    font-weight: 600;
  }
}
</style>
